import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { allProducts, productCategories } from '@/mocks/products';
import ProductCard from './ProductCard';

export default function ProductsGrid() {
  const { t } = useTranslation();
  const [activeCategory, setActiveCategory] = useState('Tümü');
  const [search, setSearch] = useState('');

  const filtered = allProducts.filter((p) => {
    const matchCat = activeCategory === 'Tümü' || p.category === activeCategory;
    const matchSearch = p.name.toLowerCase().includes(search.toLowerCase()) ||
      p.description.toLowerCase().includes(search.toLowerCase());
    return matchCat && matchSearch;
  });

  const getCategoryLabel = (cat: string) => {
    const key = `products.categories.${cat}`;
    const translated = t(key);
    return translated !== key ? translated : cat;
  };

  return (
    <section className="bg-gray-50 py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 mb-10">
          <div className="flex flex-wrap gap-2">
            {productCategories.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`px-4 py-2 rounded-full text-xs tracking-wide transition-all duration-300 cursor-pointer whitespace-nowrap font-medium ${
                  activeCategory === cat
                    ? 'bg-amber-500 text-white'
                    : 'bg-white text-gray-600 border border-gray-200 hover:border-amber-300 hover:text-amber-600'
                }`}
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                {getCategoryLabel(cat)}
              </button>
            ))}
          </div>
          <div className="relative w-full md:w-64">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder={t('products.grid.searchPlaceholder')}
              className="w-full bg-white border border-gray-200 rounded-full pl-9 pr-4 py-2.5 text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-amber-400 transition-colors"
              style={{ fontFamily: "'Inter', sans-serif" }}
            />
          </div>
        </div>

        <p className="text-gray-400 text-xs mb-6" style={{ fontFamily: "'Inter', sans-serif" }}>
          {t('products.grid.count', { count: filtered.length })}
        </p>

        {filtered.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
            {filtered.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        ) : (
          <div className="text-center py-24">
            <div className="w-14 h-14 flex items-center justify-center bg-gray-100 rounded-full mx-auto mb-4">
              <i className="ri-search-line text-gray-400 text-xl" />
            </div>
            <p className="text-gray-500 text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>
              {t('products.grid.noResults')}
            </p>
          </div>
        )}
      </div>
    </section>
  );
}